import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { SelectedFiltersContext } from "../types";

import { createFiltersSelectionMutationOptions } from "./options";

export const usePinnedFiltersMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, readonly string[], SelectedFiltersContext>(
        createFiltersSelectionMutationOptions(queryClient),
    );
};
